import React from 'react';
import styles from './BtnOpenForm.module.scss';
import { links } from '../../constants/links';
import { useRouteMatch } from 'react-router-dom';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';
import { modalType, useModal } from '../../modalProvider';
import { useQueryClient } from 'react-query';
import { getQueryKeys } from '../../lib/getQueryKeys';
import useGetParamsForRequest from '../../hooks/useGetParamsForRequest';
import { getStreetsAvailable } from '../../../../../queries/useStreetsAvailableQuery';
import { modeRequest } from '../../../../../constants/modeRequest';
import { message } from 'antd';

const BtnOpenForm = () => {
  const match = useRouteMatch(`${links.rootWithCompany}/:companyId/:page`);

  const queryClient = useQueryClient();

  const { page, companyId } = match?.params || {};

  const { open: openPermit } = useModal(modalType.PERMIT_FORM);
  const { open: openTransport } = useModal(modalType.TRANSPORT_FORM);

  const paramsRequestPermits = useGetParamsForRequest();

  const handleClick = async (e) => {
    e.stopPropagation();

    if (page === links.permits) {
      const onSuccess = () => {
        queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
      };

      const data = await getStreetsAvailable({
        companyId,
        mode: modeRequest.PERMIT,
      });

      if (!data || !data?.length) {
        message.info(
          'У выбранной УК нет домов, доступных для добавления пропуска',
          5
        );

        return;
      }

      openPermit({ onSuccess });

      return;
    }

    const onSuccess = () => {
      queryClient.refetchQueries(getQueryKeys.transports(Number(companyId)));
    };

    const data = await getStreetsAvailable({
      companyId,
      mode: modeRequest.TRANSPOR,
    });

    if (!data || !data?.length) {
      message.info('У выбранной УК нет домов, доступных для добавления ТС', 3);

      return;
    }

    openTransport({ companyId: Number(companyId), onSuccess });
  };

  return (
    <RoundedButton
      text={page === links.transports ? 'Добавить ТС' : 'Добавить пропуск'}
      className={styles.root}
      onClick={handleClick}
    />
  );
};

export default BtnOpenForm;
